require('./_wks-define')('asyncIterator');


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/core-js/modules/es7.symbol.async-iterator.js
 ** module id = 255
 ** module chunks = 12
 **/